import { render } from "./questionThree.vue?vue&type=template&id=a6bb7908"
import script from "./questionThree.vue?vue&type=script&lang=ts"
export * from "./questionThree.vue?vue&type=script&lang=ts"

import "./questionThree.vue?vue&type=style&index=0&id=a6bb7908&lang=css"
script.render = render

export default script